import React from 'react';
import { View, StyleSheet } from 'react-native';

import Modal from '../Modal/Modal';
import Button from './PopupModalButton';
import ButtonContainer from './PopupModalButtonContainer';
import Content from './PopupModalContent';
import Header from './PopupModalHeader';

import R from 'common/res/R';

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: R.color.uiLightPrimary,
    borderRadius: 2,
    ...R.elevation.container,
  },
});

class PopupModal extends React.Component {
  static Button = Button;
  static ButtonContainer = ButtonContainer;
  static Content = Content;
  static Header = Header;

  render() {
    const { modalContainerStyle, children, ...modalProps } = this.props;

    return (
      <Modal {...modalProps}>
        <View style={[styles.modalContainer, modalContainerStyle]}>
          {children}
        </View>
      </Modal>
    );
  }
}

export default PopupModal;
